/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.20.0
 * @since 1.19.0
 */

import { memo } from 'react';

import isEqual from 'lodash/isEqual';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import omit from 'lodash/omit';
import { useSelector } from 'react-redux';

import { Select } from '../../../../components/common';
import { IOptionItemProps, ISelectProps } from '../../../../components/common/Select/Select';
import { atou, utoa } from '../../../../utils/URIEncode';
import { makeSelectTranslationCommon } from '../../../internationalization/intSelectors';
import { useTableFilterApi } from '../../api';
import { useTableFilter } from './hooks/useTableFilter';

interface ITableFilterSelect extends Partial<ISelectProps> {
    name: string;
}

const TableFilterSelect = ({ name, ...props }: ITableFilterSelect) => {


    const translationCommon = useSelector(makeSelectTranslationCommon());

    /* API */

    const apiFilter = useTableFilterApi();

    const {
        filters,
        facets,
        selectedFilter,
    } = useTableFilter(name);


    const options: IOptionItemProps[] = facets || [];
    const selectedValue = isString(selectedFilter?.value) ? atou(selectedFilter?.value) : selectedFilter?.value;
    const selectedOption = options.find(option => option.value === selectedValue);

    const onSelect = (e: IOptionItemProps) => {
        if (!isEqual(e, selectedOption) && (e.value || e.value === 0)) {
            apiFilter.filter({
                ...filters,
                [name]: {
                    value: isNumber(e.value) ? e.value : utoa(e.value.toString()),
                },
            });
        } else if (selectedOption && !e.value) {
            apiFilter.filter(omit(filters, name));
        }
    };

    return <Select
        renderInBody
        kind="normal"
        options={[{ label: translationCommon.select.placeholder, value: '' }, ...options]}
        placeholder={translationCommon.select.searchPlaceholder}
        selectedOption={selectedOption}
        translation={translationCommon}

        onSelect={onSelect}

        {...props}
    />;
};

export default memo(TableFilterSelect);
